export const GMO_ERROR_CODE = {
  // 通信エラー
  E00: {
    CODES: ["E99", "E00000010", "E00000001", "E00000002", "E00000003"],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  // 決済共通エラー
  E01: {
    CODES: [
      "E01010001",
      "E01010008",
      "E01010010",
      "E01020001",
      "E01020008",
      "E01030002",
      "E01030061",
      "E01040001",
      "E01040003",
      "E01040010",
      "E01040013",
      "E01050001",
      "E01050002",
      "E01050004",
      "E01060001",
      "E01060005",
      "E01060006",
      "E01060010",
      "E01060011",
      "E01060021",
      "E01070005",
      "E01070006",
      "E01080007",
      "E01080010",
      "E01080101",
      "E01090001",
      "E01090008",
      "E01100001",
      "E01100008",
      "E01110002",
      "E01110010",
      "E01130012",
      "E01160001",
      "E01160007",
      "E01160010",
      "E01170001",
      "E01170003",
      "E01170006",
      "E01170011",
      "E01180001",
      "E01180003",
      "E01180006",
      "E01180008",
      "E01180011",
      "E01190001",
      "E01190008",
      "E01200001",
      "E01200007",
      "E01200008",
      "E01210002",
      "E01220001",
      "E01220005",
      "E01220008",
      "E01220010",
      "E01220012",
      "E01230001",
      "E01230006",
      "E01230009",
      "E01240002",
      "E01240012",
      "E01290001",
      "E01300001",
      "E01310001",
      "E01320012",
      "E01320013",
      "E01330012",
      "E01330013",
      "E01340012",
      "E01340013",
      "E01350001",
      "E01350008",
      "E01360001",
      "E01370008",
      "E01370012",
      "E01390002",
      "E01390010",
      "E01400007",
      "E01410010",
      "E01420010",
      "E01430012",
      "E01440008",
      "E01450008",
      "E01460008",
      "E01470008",
      "E01480008",
      "E01480011",
      "E01490005",
      "E01500001",
      "E01500005",
      "E01500012",
      "E01510001",
      "E01510005",
      "E01510010",
      "E01510011",
      "E01510012",
      "E01520002",
      "E01530001",
      "E01530005",
      "E01540005",
      "E01550001",
      "E01550005",
      "E01550006",
      "E01590005",
      "E01590006",
      "E01600001",
      "E01600005",
      "E01600012",
      "E01610005",
      "E01610006",
      "E01620005",
      "E01620006",
      "E01630010",
      "E01640010",
      "E01650012",
      "E01660013",
      "E01670013",
      "E01700001",
      "E01710001",
      "E01710002",
      "E01730001",
      "E01730005",
      "E01730006",
      "E01730007",
      "E01740001",
      "E01740005",
      "E01740007",
      "E01750001",
      "E01750008",
      "E01770002",
      "E01780002",
      "E01790007",
      "E01790011",
      "E01800001",
      "E01800008",
      "E01800010",
      "E01800050",
      "E01810001",
      "E01810008",
      "E01820001",
      "E01820003",
      "E01820008",
      "E01840010",
      "E01850008",
      "E01860008",
      "E01870008",
      "E01880001",
      "E01880002",
      "E01880008",
      "E01890001",
      "E01890002",
      "E01890006",
      "E01890009",
      "E01910008",
      "E01920008",
      "E01950008",
      "E01960008",
      "E01970008",
      "E01980008",
      "E01990005",
      "E01990006",
      "E01999998",
      "E01A00008",
      "E01A10005",
      "E01A10006",
      "E01A20008",
      "E01A30008",
      "E01A40008",
      "E01A50005",
      "E01A50006",
      "E01A60005",
      "E01A60006",
      "E01A70012",
      "E01A80008",
      "E01A90008",
      "E01B00008",
      "E01B10005",
      "E01B20002",
      "E01B20005",
      "E01B30005",
      "E01B40005",
      "E01B50005",
      "E01B60005",
      "E01B70005",
      "E01B70008",
      "E01B70010",
      "E01B80005",
      "E01B80008",
      "E01B90005",
      "E01C00005",
      "E01C00006",
      "E01C10005",
      "E01C20005",
      "E01C20006",
      "E01C30005",
      "E01C40005",
      "E01C40006",
      "E01C50005",
      "E01C60002",
      "E01C60005",
      "E01C70005",
      "E01C80005",
      "E01C90005",
      "E01D00005",
      "E01D10005",
      "E01D10008",
      "E01D10010",
      "E01D20005",
      "E01D20008",
      "E01D30008",
      "E01D40005",
      "E01D40006",
      "E01D50005",
      "E01D50006",
      "E01D60005",
      "E01D70008",
      "E01D80008",
      "E01D90008",
      "E01E00008",
      "E01E10008",
      "E01E20005",
      "E01E20006",
      "E01E30001",
      "E01E30005",
      "E01E30008",
      "E01E50001",
      "E01E50004",
      "E01E50008",
      "E01E60001",
      "E01E70001",
      "E01E80001",
      "E01E90001",
      "E01EA0007",
      "E01EA0010",
      "E01EB0001",
      "E01EB0005",
      "E01EC0002",
      "E01EE0001",
      "E01EE0008",
      "E01EF0001",
      "E01EF0005",
      "E01EG0001",
      "E01EG0008",
      "E01EV0001",
      "E01EV0008",
      "E01EV0006",
      "E01EW0001",
      "E01EW0005",
      "E01EX0001",
      "E01EX0008",
      "E01EY0007",
      "E01EZ0008",
      "E01144001",
      "E01144010",
    ],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  // カードエラー
  E10: {
    CODES: [
      "E01250008",
      "E01250010",
      "E01260001",
      "E01260002",
      "E01260010",
      "E01270001",
      "E01270005",
      "E01270006",
      "E01270010",
    ],
    MESSAGE: `指定されたカード番号または支払方法が正しくありません。\n再度確認して入力してください。`,
  },
  // 取引エラー
  E11: {
    CODES: [
      "E11010001",
      "E11010002",
      "E11010003",
      "E11010004",
      "E11010010",
      "E11010099",
      "E11010100",
      "E11010999",
      "E11310001",
      "E11310002",
      "E11310003",
      "E11310004",
      "E11310005",
    ],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  E41: {
    CODES: ["E41170099"],
    MESSAGE: `カード番号に誤りがあります。再度確認して入力してください。`,
  },
  // 加盟店設定エラー
  E61: {
    CODES: [
      "E61010001",
      "E61010002",
      "E61010003",
      "E61020001",
      "E61030001",
      "E61040001",
      "E61145002",
      "E61544002",
      "E61546010",
    ],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  // 実行の排他エラー
  E81: {
    CODES: ["E82010001"],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  //システムエラー(通信)
  E90: {
    CODES: ["E90010001"],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  //システムエラー(通信)
  E91: {
    CODES: [
      "E91099996",
      "E91099997",
      "E91019999",
      "E91020001",
      "E91029998",
      "E91029999",
      "E91060001",
      "E91099999",
    ],
    MESSAGE: `決済会社側のサーバーエラーで処理が中断しました。決済は未完了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  //流量制限オーバーエラー
  E92: {
    CODES: ["E92000001", "E92000002"],
    MESSAGE: `只今、大変込み合っていますので、しばらく時間をあけて再度決済を行ってください。`,
  },
  //トークンエラー
  EX1: {
    CODES: ["EX1000301", "EX1000302", "EX1000303", "EX1000304"],
    MESSAGE: `決済処理に失敗しました。もう一度カード番号を入力してください。`,
  },
  // CAFISもしくはカード会社返却エラーコード(C系)
  C00: {
    CODES: [
      "42C010000",
      "42C030000",
      "42C120000",
      "42C130000",
      "42C140000",
      "42C150000",
      "42C330000",
      "42C500000",
      "42C510000",
      "42C530000",
      "42C540000",
      "42C550000",
      "42C560000",
      "42C570000",
      "42C580000",
      "42C600000",
      "42C700000",
      "42C710000",
      "42C720000",
      "42C730000",
      "42C740000",
      "42C750000",
      "42C760000",
      "42C770000",
      "42C780000",
    ],
    MESSAGE: `決済に失敗しました。\n別の決済方法をお試しいただくか、時間を空けて再度お試しください。`,
  },
  //42G
  G02: {
    CODES: ["42G020000"],
    MESSAGE: `決済処理に失敗しました。\nカード残高が不足しているために、決済を完了する事ができませんでした。`,
  },
  G03: {
    CODES: ["42G030000", "42G050000"],
    MESSAGE: `決済処理に失敗しました。\nカード限度額を超えているために、決済を完了する事ができませんでした。`,
  },
  G04: {
    CODES: ["42G040000"],
    MESSAGE: `決済処理に失敗しました。\nカード残高が不足しているために、決済を完了する事ができませんでした。`,
  },
  G06: {
    CODES: ["42G060000"],
    MESSAGE: `決済処理に失敗しました。\nデビットカードで口座の残高が不足しています。`,
  },
  G07: {
    CODES: ["42G070000", "42G550000"],
    MESSAGE: `決済処理に失敗しました。\nカード限度額を超えているために、決済を完了する事ができませんでした。`,
  },
  G12: {
    CODES: [
      "42G120000",
      "42G220000",
      "42G300000",
      "42G950000",
      "42G960000",
      "42G970000",
      "42G990000",
    ],
    MESSAGE: `決済処理に失敗しました。\nこのカードでは取引をする事ができません。`,
  },
  G42: {
    CODES: ["42G420000", "42G430000"],
    MESSAGE: `決済処理に失敗しました。\n暗証番号が誤っていた為に、決済を完了する事ができませんでした。`,
  },
  G44: {
    CODES: ["42G440000", "42G450000"],
    MESSAGE: `決済処理に失敗しました。\nセキュリティーコードが誤っていた為に、決済を完了する事ができませんでした。`,
  },
  G54: {
    CODES: ["42G540000", "42G560000", "42G600000", "42G610000"],
    MESSAGE: `決済処理に失敗しました。\nこのカードでは取引をする事ができません。`,
  },
  G65: {
    CODES: ["42G650000"],
    MESSAGE: `決済処理に失敗しました。\nカード番号に誤りがあるために、決済を完了する事ができませんでした。`,
  },
  G91: {
    CODES: ["42G910000"],
    MESSAGE: `決済処理に失敗しました。\nシステム障害のために、決済を完了する事ができませんでした。`,
  },
  M01: {
    CODES: [
      "M01001005",
      "M01002001",
      "M01002002",
      "M01002008",
      "M01002010",
      "M01003001",
      "M01003008",
      "M01004001",
      "M01004002",
      "M01004010",
      "M01004012",
      "M01004013",
      "M01004014",
      "M01005001",
      "M01005002",
      "M01005005",
      "M01005006",
      "M01005011",
      "M01006002",
      "M01006005",
      "M01006006",
      "M01006011",
      "M01007001",
      "M01007008",
      "M01008001",
      "M01008008",
      "M01014001",
      "M01014005",
      "M01014008",
      "M01015005",
      "M01015008",
      "M01043001",
      "M01043012",
      "M01043013",
      "M01052011",
      "M01054001",
      "M01054004",
      "M01054010",
      "M01058002",
      "M01058010",
      "M01059001",
      "M01059005",
      "M01059012",
      "M01080001",
      "M01080005",
      "M01080013",
      "M01082001",
      "M01082005",
      "M01082013",
      "M01083001",
      "M01083005",
      "M01083008",
      "M01135005",
      "M01135010",
      "M01135013",
      "M01136001",
      "M01136005",
      "M01137005",
      "M01135005",
      "M01135010",
      "M01135013",
      "M01136001",
      "M01136005",
      "M01137005",
      "M01148010",
      "M01150001",
      "M01151005",
      "M01460005",
      "M01719003",
      "M01720008",
      "M01720012",
      "M01909008",
    ],
    MESSAGE: `処理中にシステムエラーが発生しました。決済は未了です。\nお手数ですが、コールセンターへお問い合わせください。`,
  },
  PP1: {
    CODES: ["PP1007009"],
    MESSAGE: `決済処理に失敗しました。\n別の決済方法をお試しいただくか、時間を空けて再度お試しください。`,
  },
  LP1: {
    CODES: ["LP1001150", "LP1001180", "LP2009900", "LP2009999"],
    MESSAGE: `決済処理に失敗しました。\n別の決済方法をお試しいただくか、時間を空けて再度お試しください。`,
  },
  // モバイルSuica
  S00: {
    CODES: ["S01000002"],
    MESSAGE: `決済受付メールの処理中にエラーが発生しました。決済は未了です。\nお手数ですが、モバイルSuicaアプリのネット決済一覧から決済を行ってください。`,
  },
  S01: {
    CODES: [
      "S01001001",
      "S01001002",
      "S01001006",
      "S01001007",
      "S01001008",
      "S01001010",
      "S01001012",
      "S01001015",
      "S01001016",
      "S01001017",
      "S01009901",
      "S01009902",
    ],
    MESSAGE: `決済処理に失敗しました。\n別の決済方法をお試しいただくか、時間を空けて再度お試しください。`,
  },
  // au
  AMP: {
    CODES: [
      "AMPL20008",
      "AMPL20009",
      "AMPL20010",
      "AMPL20011",
      "AMPL21010",
      "AMPL22000",
      "AMPL30000",
      "AMPL30075",
      "AMPL30117",
      "AMPL30026",
      "AMPL40004",
      "AMPL40005",
      "AMPL40006",
      "AMPL40011",
      "AMPL40104",
      "AMPL40305",
    ],
    MESSAGE: `決済に失敗しました。\n別の決済方法をお試しいただくか、時間を空けて再度お試しください。`,
  },
};
